import React from "react";
import { cn } from "@/libs/utils";
import styles from "./WordpressStyleDiv.module.css";

type WordpressStyleDivProps = React.HTMLAttributes<HTMLDivElement>;

const WordpressStyleDiv = React.forwardRef<
  HTMLDivElement,
  WordpressStyleDivProps
>(({ className, children, ...props }, ref) => (
  <div ref={ref} className={cn(styles.wordpressStyle, className)} {...props}>
    {children}
  </div>
));

WordpressStyleDiv.displayName = "WordpressStyleDiv";

export default WordpressStyleDiv;
